import app from '@/app';

/* @ngInject */
function Resource($resource) {
	return $resource(
		'api/costtablehistorics/:version/:idplan',
		{ idplan: '@idplan',
      version: '@version'},
		{
			query: { method: 'GET' }
		}
	);
}

app.factory('CostTableHistoric', Resource);



